import { render, staticRenderFns } from "./EvTemplateVehiclePanel.vue?vue&type=template&id=1b90ea69&scoped=true"
import script from "./EvTemplateVehiclePanel.vue?vue&type=script&lang=js"
export * from "./EvTemplateVehiclePanel.vue?vue&type=script&lang=js"
import style0 from "./EvTemplateVehiclePanel.vue?vue&type=style&index=0&id=1b90ea69&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b90ea69",
  null
  
)

export default component.exports